import { render, staticRenderFns } from "./EntryPointPageTemplate.vue?vue&type=template&id=ecbf9de4&"
import script from "./EntryPointPageTemplate.vue?vue&type=script&lang=js&"
export * from "./EntryPointPageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports